export const GET_FAILEDEXPORTS = 'GET_FAILEDEXPORTS'
export const GET_FAILEDEXPORTS_SUCCESS = 'GET_FAILEDEXPORTS_SUCCESS'
export const GET_FAILEDEXPORTS_FAILED = 'GET_FAILEDEXPORTS_FAILED'
